/**
 * The query string the admin Alerts list sends to GET /admin/alerts. Pure,
 * unit-tested in alertListQuery.test.ts.
 */
import type { AlertRow } from './api';

/** Every status but resolved, matching OPEN_ALERT_STATUSES in apps/api/src/lib/alertSubjects.ts. */
export const OPEN_ALERT_STATUSES: readonly AlertRow['status'][] = [
  'detected', 'notified', 'action_pending', 'escalated',
];

export interface AlertListFilter {
  /** 'open' is every unresolved status. */
  status?: AlertRow['status'] | 'open';
  severity?: AlertRow['severity'];
  charger_id?: string;
  rule_id?: string;
  from?: string;
  to?: string;
  page?: number;
  page_size?: number;
}

/**
 * "All open" goes out as the four unresolved statuses, one `status` param
 * each, not as status=open. The route reads a repeated param as "any of
 * these", and the Api build before 'open' existed reads it the same way
 * (it passed the array into the Mongo filter, which casts it to $in), so
 * the list stays right whichever Api is live while Api and Admin roll out.
 */
export function alertListSearchParams(filter: AlertListFilter): URLSearchParams {
  const sp = new URLSearchParams();
  for (const [k, v] of Object.entries(filter)) {
    if (v === undefined || v === '') continue;
    if (k === 'status' && v === 'open') {
      for (const s of OPEN_ALERT_STATUSES) sp.append('status', s);
    } else {
      sp.set(k, String(v));
    }
  }
  return sp;
}
